var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:_vm.$style.footer},[_c('footer-nav'),_c('download-whale')],1)}
var staticRenderFns = []

export { render, staticRenderFns }